export const LOGIN_LINK_COOLDOWN_MS = 30000;
